// extracted by mini-css-extract-plugin
export default {"movies":"Home_movies__gwr3f"};